{
  "v": "5.7.13",
  "fr": 30,
  "ip": 0,
  "op": 30,
  "w": 30,
  "h": 30,
  "nm": "icon_home_trimmed_30x30",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Home 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [ 15, 15, 0 ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 21, 19, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [ 50, 50, 100 ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 1,
                      "y": 0
                    },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [ 0, 0 ],
                          [ 0.328, 0.323 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ 0.201, -0.198 ],
                          [ 0, 0 ],
                          [ -0.46, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ],
                          [ -0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ -0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ],
                          [ -0.285, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ -0.284, 0 ]
                        ],
                        "o": [
                          [ 0.461, 0 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ -0.201, -0.198 ],
                          [ 0, 0 ],
                          [ -0.327, 0.323 ],
                          [ 0, 0 ],
                          [ 0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ 0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ],
                          [ 0.285, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ 0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ]
                        ],
                        "v": [
                          [ 19.481, 2.002 ],
                          [ 19.843, 1.121 ],
                          [ 16.46, -2.227 ],
                          [ 11.284, -7.348 ],
                          [ 0.361, -17.967 ],
                          [ -0.364, -17.967 ],
                          [ -19.849, 1.121 ],
                          [ -19.486, 2.002 ],
                          [ -16.519, 2.004 ],
                          [ -16.004, 2.52 ],
                          [ -16.004, 17.511 ],
                          [ -15.489, 18.026 ],
                          [ -4.496, 18.017 ],
                          [ -3.981, 17.502 ],
                          [ -3.981, 8.475 ],
                          [ -3.466, 7.96 ],
                          [ 3.497, 7.947 ],
                          [ 4.012, 8.462 ],
                          [ 4.012, 17.489 ],
                          [ 4.528, 18.004 ],
                          [ 15.492, 18.025 ],
                          [ 16.007, 17.51 ],
                          [ 16.007, 2.519 ],
                          [ 16.522, 2.003 ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 7,
                    "s": [
                      {
                        "i": [
                          [ 0, 0 ],
                          [ 0.328, 0.323 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ 0.201, -0.198 ],
                          [ 0, 0 ],
                          [ -0.46, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ],
                          [ -0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ -0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ],
                          [ -0.285, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ -0.284, 0 ]
                        ],
                        "o": [
                          [ 0.461, 0 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ -0.201, -0.198 ],
                          [ 0, 0 ],
                          [ -0.327, 0.323 ],
                          [ 0, 0 ],
                          [ 0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ 0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ],
                          [ 0.285, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ 0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ]
                        ],
                        "v": [
                          [ 19.481, 2.002 ],
                          [ 19.843, 1.121 ],
                          [ 16.46, -2.227 ],
                          [ 11.284, -7.348 ],
                          [ 0.361, -17.967 ],
                          [ -0.364, -17.967 ],
                          [ -19.849, 1.121 ],
                          [ -19.486, 2.002 ],
                          [ -16.519, 2.004 ],
                          [ -16.004, 2.52 ],
                          [ -16.004, 17.511 ],
                          [ -15.489, 18.026 ],
                          [ 3.441, 18.02 ],
                          [ 3.956, 17.505 ],
                          [ 3.956, 8.478 ],
                          [ 4.471, 7.963 ],
                          [ 3.497, 7.947 ],
                          [ 4.012, 8.462 ],
                          [ 4.012, 17.489 ],
                          [ 4.528, 18.004 ],
                          [ 15.492, 18.025 ],
                          [ 16.007, 17.51 ],
                          [ 16.007, 2.519 ],
                          [ 16.522, 2.003 ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.232,
                      "y": 0.003
                    },
                    "o": {
                      "x": 1,
                      "y": 0
                    },
                    "t": 12,
                    "s": [
                      {
                        "i": [
                          [ 0, 0 ],
                          [ 0.328, 0.323 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ 0.201, -0.198 ],
                          [ 0, 0 ],
                          [ -0.46, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ],
                          [ -0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ -0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ],
                          [ -0.285, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ -0.284, 0 ]
                        ],
                        "o": [
                          [ 0.461, 0 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ -0.201, -0.198 ],
                          [ 0, 0 ],
                          [ -0.327, 0.323 ],
                          [ 0, 0 ],
                          [ 0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ 0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ],
                          [ 0.285, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ 0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ]
                        ],
                        "v": [
                          [ 19.481, 2.002 ],
                          [ 19.843, 1.121 ],
                          [ 16.46, -2.227 ],
                          [ 11.284, -7.348 ],
                          [ 0.361, -17.967 ],
                          [ -0.364, -17.967 ],
                          [ -19.849, 1.121 ],
                          [ -19.486, 2.002 ],
                          [ -16.519, 2.004 ],
                          [ -16.004, 2.52 ],
                          [ -16.004, 17.511 ],
                          [ -15.489, 18.026 ],
                          [ 3.441, 18.02 ],
                          [ 3.956, 17.505 ],
                          [ 3.956, 8.478 ],
                          [ 4.471, 7.963 ],
                          [ 3.497, 7.947 ],
                          [ 4.012, 8.462 ],
                          [ 4.012, 17.489 ],
                          [ 4.528, 18.004 ],
                          [ 15.492, 18.025 ],
                          [ 16.007, 17.51 ],
                          [ 16.007, 2.519 ],
                          [ 16.522, 2.003 ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 20,
                    "s": [
                      {
                        "i": [
                          [ 0, 0 ],
                          [ 0.328, 0.323 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ 0.201, -0.198 ],
                          [ 0, 0 ],
                          [ -0.46, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ],
                          [ -0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ -0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ],
                          [ -0.285, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ -0.284, 0 ]
                        ],
                        "o": [
                          [ 0.461, 0 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ 0, 0 ],
                          [ -0.201, -0.198 ],
                          [ 0, 0 ],
                          [ -0.327, 0.323 ],
                          [ 0, 0 ],
                          [ 0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ 0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ],
                          [ 0.285, 0 ],
                          [ 0, 0 ],
                          [ 0, 0.285 ],
                          [ 0, 0 ],
                          [ 0.284, 0 ],
                          [ 0, 0 ],
                          [ 0, -0.285 ],
                          [ 0, 0 ]
                        ],
                        "v": [
                          [ 19.481, 2.002 ],
                          [ 19.843, 1.121 ],
                          [ 16.46, -2.227 ],
                          [ 11.284, -7.348 ],
                          [ 0.361, -17.967 ],
                          [ -0.364, -17.967 ],
                          [ -19.849, 1.121 ],
                          [ -19.486, 2.002 ],
                          [ -16.519, 2.004 ],
                          [ -16.004, 2.52 ],
                          [ -16.004, 17.511 ],
                          [ -15.489, 18.026 ],
                          [ -4.496, 18.017 ],
                          [ -3.981, 17.502 ],
                          [ -3.981, 8.475 ],
                          [ -3.466, 7.96 ],
                          [ 3.497, 7.947 ],
                          [ 4.012, 8.462 ],
                          [ 4.012, 17.489 ],
                          [ 4.528, 18.004 ],
                          [ 15.492, 18.025 ],
                          [ 16.007, 17.51 ],
                          [ 16.007, 2.519 ],
                          [ 16.522, 2.003 ]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0, 0.450980422076, 0.741176470588, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 21, 18.975 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 30,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": [
    {
      "tm": 20,
      "cm": "1",
      "dr": 0
    }
  ]
}